// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__sq8O-","btn-sm":"Button_btn-sm__gknsZ"};